var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"main-header"},[_c('div',{staticClass:"container container-md-lg"},[_c('div',{staticClass:"header-wrap wrap-lg"},[_c('div',{staticClass:"header-logo"},[_c('router-link',{attrs:{"tag":"a","to":{
            name: 'userdashboard'
          }}},[_c('img',{attrs:{"src":_vm.logo,"alt":"logo"}})])],1),_vm._v(" "),_c('div',{staticClass:"header-right"},[_c('div',{staticClass:"header-right"},[_c('h4',[_vm._v(_vm._s(_vm.regimen.id ? 'Update' : 'Add New')+" Preset Regimen")])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }